import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import {Tooltip as TooltipComponent} from '@mui/material';
import React from 'react';

import TooltipProps from '../Interfaces/TooltipProps';

/**
 * Customized Tooltip with message as prop
 * @component
 */
const Tooltip: React.FC<TooltipProps> = ({message}) => {
  return (
    <TooltipComponent title={message} arrow disableFocusListener>
      <InfoOutlinedIcon sx={{color: '#99B1C7'}} />
    </TooltipComponent>
  );
};

export default Tooltip;
